/**
 *
 * MaterialCourseCpnt
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
//import Swal from 'sweetalert2';

import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';

export default {
  name: 'MaterialCourseCpnt',

  mixins: [ClassRestrictionMixin],

  data() {
    return {
      selectedFileId: -1,
    };
  },

  computed: {
    ...mapState('MainModeCourse', {
      ms_isMaterialLoading: 'isMaterialLoading',
    }),

    ...mapGetters({
      Course: 'MainModeCourse/Course',
      Files: 'MainModeCourse/Files',
    }),

    ///
    c_courseId() {
      return Number(this.$route.params.courseId);
    },

    c_selectedFile() {
      const selectedFile = _.find(this.Files, (file) => file.fileId === this.selectedFileId);
      return selectedFile ? selectedFile : {};
    },

    ///
    c_restrictStudent() {
      return this.Course.restrictStudent;
    },
  },

  methods: {
    ...mapActions('MainModeCourse', {
      ma_getClassRestrictionWebTreePath: 'getClassRestrictionWebTreePath',
    }),

    async downloadMaterial(file) {
      this.selectedFileId = file.fileId;
      if (!this.c_selectedFile.filePath) {
        await this.ma_getClassRestrictionWebTreePath(file);
      }
      window.open(this.c_selectedFile.filePath, '_blank');
    },

    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = window.promiseGetCourse;
    },
  },
};
